/* global axios */
import ApiClient from '../ApiClient';

// Tạo hộp thư Zalo bằng MỘT cú bấm.
//
// Chỉ gửi lên cái TÊN. URL webhook (kèm secret của bridge) do server tự đọc từ
// cấu hình — secret không bao giờ đi xuống trình duyệt. Xem
// `app/controllers/api/v1/accounts/bonboz/zalo_controller.rb`.
class ZaloAPI extends ApiClient {
  constructor() {
    super('bonboz/zalo', { accountScoped: true });
  }

  taoHopThu(name) {
    return axios.post(this.url, { name });
  }

  // Kết bạn / panel "Cuộc trò chuyện mới": Rails proxy sang cầu nối.
  // `inboxId` = hộp thư Zalo. Lỗi trả `{ error, loi }` — đọc bằng `loiApi`.
  banBe(inboxId) {
    return axios.get(`${this.url}/${inboxId}/ban_be`);
  }

  loiMoiDen(inboxId) {
    return axios.get(`${this.url}/${inboxId}/loi_moi_den`);
  }

  timSdt(inboxId, sdt) {
    return axios.get(`${this.url}/${inboxId}/tim_sdt`, { params: { sdt } });
  }

  // `hoSo` = { ten, avatar } panel đã hiện cho nhân viên thấy. Gửi kèm để bridge đặt
  // tên contact ngay — khách CHƯA KẾT BẠN thì Zalo không cho đọc hồ sơ, không có cái
  // này contact mang tên là dãy số uid. Xem `nhan_tin` ở zalo_ket_ban_controller.rb.
  guiLoiMoi(inboxId, uid, loiNhan, hoSo = {}) {
    return axios.post(`${this.url}/${inboxId}/gui_loi_moi`, {
      uid,
      loi_nhan: loiNhan,
      ...hoSo,
    });
  }

  dongY(inboxId, uid, hoSo = {}) {
    return axios.post(`${this.url}/${inboxId}/dong_y`, { uid, ...hoSo });
  }

  tuChoi(inboxId, uid) {
    return axios.post(`${this.url}/${inboxId}/tu_choi`, { uid });
  }

  nhanTin(inboxId, uid, hoSo = {}) {
    return axios.post(`${this.url}/${inboxId}/nhan_tin`, { uid, ...hoSo });
  }

  taoNhom(inboxId, ten, thanhVien) {
    return axios.post(`${this.url}/${inboxId}/tao_nhom`, {
      ten,
      thanh_vien: thanhVien,
    });
  }
}

export default new ZaloAPI();
